import { useContext } from 'react';
import { IdentityContext, IdentityContextType } from '../contexts/identity_context';

const useIdentity = () => {
    return useContext(IdentityContext) as IdentityContextType;
};

export default useIdentity;
